import type { AccentHue } from "@repo/fika-design-system/color"
import { useNavigate } from "@solidjs/router"
import { For, type ParentProps, splitProps } from "solid-js"
import { Box } from "../components/box"
import { FikaLogo } from "../components/fika-logo"
import { Icon } from "../components/icon"
import { NavLink } from "../components/nav-link"
import {
  backButtonClass,
  breadcrumbsClass,
  headerClass,
  slashClass,
  textClass,
} from "./navigation.css"

type Link = {
  label: string
  href: string
}

type Props = {
  buttons?: Link[]
  title: string
  hue: AccentHue
  backTo?: string
}
export function Navigation(props: Props) {
  const navigate = useNavigate()

  const backHref = () => {
    if (props.backTo) return props.backTo
    const lastButton = props.buttons?.at(-1)
    if (lastButton) return lastButton.href
    return "/"
  }

  return (
    <Box gap="12" flexDirection="row">
      <nav class={headerClass}>
        <button
          type="button"
          class={backButtonClass}
          onClick={() => navigate(backHref())}
        >
          <Icon name="arrow-left" size="18" />
        </button>
        <span class={breadcrumbsClass}>
          <FikaLogo link />
          <For each={props.buttons}>
            {button => (
              <>
                <span class={slashClass}>
                  <Icon name="chevron-right" size="18" color="sand500" />
                </span>
                <NavLink href={button.href} hue={props.hue} noScroll>
                  {button.label}
                </NavLink>
              </>
            )}
          </For>
          <span class={slashClass}>
            <Icon name="chevron-right" size="18" color="sand500" />
          </span>
        </span>
        <span class={textClass}>{props.title}</span>
      </nav>
    </Box>
  )
}

export function NavigationWithButtons(props: Props & ParentProps) {
  const [local, others] = splitProps(props, ["children"])

  return (
    <Box
      alignItems="center"
      justifyContent="space-between"
      flexDirection="row"
      gap="24"
    >
      <Navigation {...others} />
      <Box gap="12" flexDirection="row" alignItems="center">
        {local.children}
      </Box>
    </Box>
  )
}
